import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCFH0qH2RW7jEcXpER_XazfCYaUckr_5z8",
  authDomain: "content2learn-bf425.firebaseapp.com",
  projectId: "content2learn-bf425",
  storageBucket: "content2learn-bf425.firebasestorage.app",
  messagingSenderId: "871161229212",
  appId: "1:871161229212:web:831923b17643798668e259",
  measurementId: "G-0Q5PGWYBZE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { app, auth, db };